<mf-page title="Nueva pasarela">
  <mf-gateway
    (close)="close()"
    (save)="save($event)" />
</mf-page>
